import React from 'react';
import { connect } from 'react-redux';
import TermsTemplate from 'view/TermsTemplate';
import Summary from '../Summary';
import Content from '../Content';
import './../terms-template.scss';
import './terms-of-use.scss';

const TermsOfUse = ({ i18n }) => {
    const { locale, translations } = i18n;
    const { headline, summary, sections, copyright } = translations[locale]['terms-of-use'];

    return (
        <TermsTemplate containerStyle="terms-of-use">
            <h1>{ headline }</h1>
            <main className="container">
                <Summary summary={ summary } />
                <Content items={ sections } />
                <Summary summary={ copyright } />
            </main>
        </TermsTemplate>
    );
}

export default connect(state => ({ i18n: state.i18n }))(TermsOfUse);
